import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isPast } from 'date-fns'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import StartEndDateRangeFields from '../../../../../../ReusableFormFields/StartEndDateRangeFields'
import Spoiler from '../../../../../../../components/Spoiler'
import ToggleField from '../../../../../../../components/Form/ToggleField'

import { rightSelector } from '../../../../../../../modules/selectors/rights'

import { START_DATE, END_DATE } from '../../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import { COMMENT_DISABLED, SHARE_DISABLED, VIDEO_DOWNLOAD_DISABLED } from '../../fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [START_DATE, END_DATE, COMMENT_DISABLED, SHARE_DISABLED, VIDEO_DOWNLOAD_DISABLED]

const DatesStep = ({ formik, handleStepChange }) => {
  const drawerFormClasses = useDrawerFormStyles()

  const { t } = useTranslation()

  const right = useSelector(rightSelector)

  const { start_date: rightStartDate, end_date: rightEndDate } = right

  const isRightStartDateInThePast = useMemo(() => isPast(new Date(rightStartDate)), [rightStartDate])

  const minStartDate = useMemo(
    () => (isRightStartDateInThePast ? new Date() : rightStartDate),
    [isRightStartDateInThePast, rightStartDate]
  )

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  const { values, setFieldValue } = formik

  console.log('values', values)

  return (
    <Step stepTitle="What should the start and end dates be?" handleContinue={handleContinue}>
      <section className={drawerFormClasses.section}>
        <div className={drawerFormClasses.sectionTitle}>{t('Start and end dates')}</div>
        <p>
          {t(
            `Please enter the start and end date for this ad group. You can select any dates within the agreed period from ${rightStartDate} to ${rightEndDate}.`
          )}
        </p>
        <StartEndDateRangeFields formik={formik} minDate={minStartDate} maxDate={rightEndDate} />
      </section>

      <Spoiler title={t('Advanced settings')}>
        <div className={drawerFormClasses.section}>
          <ToggleField
            name={COMMENT_DISABLED}
            isEnabled={!values[COMMENT_DISABLED]}
            setFieldValue={setFieldValue}
            label={values[COMMENT_DISABLED] ? 'Comments disabled' : 'Comments enabled'}
            hasReversedNaming={true}
          />
          <br />
          <ToggleField
            name={SHARE_DISABLED}
            isEnabled={!values[SHARE_DISABLED]}
            setFieldValue={setFieldValue}
            label={values[SHARE_DISABLED] ? 'Shares disabled' : 'Shares enabled'}
            hasReversedNaming={true}
          />
          <br />
          <ToggleField
            name={VIDEO_DOWNLOAD_DISABLED}
            isEnabled={!values[VIDEO_DOWNLOAD_DISABLED]}
            setFieldValue={setFieldValue}
            label={values[VIDEO_DOWNLOAD_DISABLED] ? 'Downloads disabled' : 'Downloads enabled'}
            hasReversedNaming={true}
          />
        </div>
      </Spoiler>
    </Step>
  )
}

export default DatesStep
